import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

export default function Landing() {
    useSEO(
        'PickOneGift — Spersonalizowane listy prezentów',
        'Stwórz listę prezentów dla siebie, znajomych lub powitalne pakiety firmowe. Dodawaj prezenty, udostępniaj link i odbieraj idealne niespodzianki!'
    );
    return (
        <div className="page">
            <Header />

            {/* Hero Section */}
            <section className="hero">
                <div className="container hero-split">
                    <div className="hero-text">
                        <h1>
                            Idealny prezent? <br />
                            <span className="gradient-text">Niech wybierze sam!</span>
                        </h1>
                        <p className="hero-subtitle">
                            Z łatwością stwórz spersonalizowaną listę prezentów i wygeneruj link.
                            Wyślij go znajomemu — a on sam wybierze, co najbardziej mu się podoba.
                            Ty dostaniesz powiadomienie z adresem wysyłki!
                        </p>
                        <div className="hero-actions">
                            <Link to="/create" className="btn btn-primary btn-lg">
                                🎁 Stwórz listę za darmo
                            </Link>
                            <Link to="/generator" className="btn btn-secondary btn-lg">
                                🪄 Kreator prezentów
                            </Link>
                        </div>
                    </div>
                    <div className="hero-visual">
                        <div className="mockup-container">
                            {/* Main background image showing emotion */}
                            <img
                                src="https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=800&q=80"
                                alt="Szczęśliwa osoba z prezentem"
                                className="mockup-image"
                            />

                            {/* Floating UI Elements */}
                            <div className="floating-card glass float-anim-1">
                                <div className="fc-icon">🎁</div>
                                <div className="fc-content">
                                    <span className="fc-title">Nowa lista prezentów</span>
                                    <span className="fc-desc">Dla: Anna (Urodziny)</span>
                                </div>
                            </div>

                            <div className="floating-card glass float-anim-2">
                                <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=100&h=100&fit=crop" alt="Sony WH-1000XM5" />
                                <div className="fc-content">
                                    <span className="fc-title">Słuchawki Sony</span>
                                    <span className="fc-desc">Dodano do listy ✓</span>
                                </div>
                            </div>

                            <div className="floating-card glass float-anim-3" style={{ background: 'var(--gradient-primary)' }}>
                                <div className="fc-icon">✅</div>
                                <div className="fc-content">
                                    <span className="fc-title" style={{ color: 'white' }}>Anna wybrała!</span>
                                    <span className="fc-desc" style={{ color: 'rgba(255,255,255,0.8)' }}>Zobacz adres wysyłki</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How it Works */}
            <section className="steps" id="how-it-works">
                <div className="container">
                    <h2 className="text-center">
                        Jak to działa?
                    </h2>
                    <div className="steps-grid">
                        <div className="card step-card fade-in">
                            <div className="step-number">1</div>
                            <h3>Stwórz listę</h3>
                            <p>
                                Dodaj prezenty, które chcesz zaproponować — tytuł, zdjęcie, link do
                                produktu. Możesz dodać od 2 do 20 pozycji.
                            </p>
                        </div>
                        <div className="card step-card fade-in">
                            <div className="step-number">2</div>
                            <h3>Wyślij link</h3>
                            <p>
                                Wygeneruj unikalny link i wyślij go znajomemu. Może go otworzyć na
                                dowolnym urządzeniu — nie potrzebuje konta.
                            </p>
                        </div>
                        <div className="card step-card fade-in">
                            <div className="step-number">3</div>
                            <h3>Otrzymaj wybór</h3>
                            <p>
                                Usiądź wygodnie i zrelaksuj się. Otrzymasz powiadomienie e-mail z
                                wybranym prezentem i adresem do wysyłki.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* For Stores */}
            <section className="steps" id="for-stores">
                <div className="container">
                    <h2 className="text-center">Dla sklepów online</h2>
                    <div className="steps-grid">
                        <div className="card step-card">
                            <div className="step-number">🏪</div>
                            <h3>Widget dla e-commerce</h3>
                            <p>
                                Dodaj nasz widget do swojego sklepu jednym tagiem script.
                                Klienci mogą dodawać produkty do listy prezentów bezpośrednio
                                ze strony produktu.
                            </p>
                        </div>
                        <div className="card step-card">
                            <div className="step-number">🔗</div>
                            <h3>Łatwa integracja</h3>
                            <p>
                                Wystarczy jeden tag &lt;script&gt; i gotowe. Widget automatycznie
                                dopasuje się do Twojego sklepu. Konfigurowalny kolor i pozycja.
                            </p>
                        </div>
                        <div className="card step-card">
                            <div className="step-number">📈</div>
                            <h3>Zwiększ sprzedaż</h3>
                            <p>
                                Klienci, którzy tworzą listy prezentów, wracają i polecają Twój
                                sklep. Nowy kanał pozyskiwania klientów.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="steps">
                <div className="container text-center">
                    <h2>Gotowy, aby rozpocząć?</h2>
                    <p className="text-muted mt-md" style={{ maxWidth: 500, margin: '16px auto' }}>
                        Stworzenie listy prezentów zajmie Ci mniej niż 2 minuty.
                        Bez rejestracji, bez opłat.
                    </p>
                    <div className="mt-lg">
                        <Link to="/create" className="btn btn-primary btn-lg">
                            🎁 Stwórz listę prezentów
                        </Link>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}
